import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContainerTankCisternLegs = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 105,
	viewBox: "0 0 100.0 105.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 0.0 L 10.0 0.0 L 10.0 70.0 L 90.0 70.0 L 90.0 0.0 L 100.0 0.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10,
			y: 70,
			width: 8,
			height: 35,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 82,
			y: 70,
			width: 8,
			height: 35,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgContainerTankCisternLegs;
